export const SET_HOME_GYM = 'SET_HOME_GYM';
